// src/components/Sidebar.jsx
import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext.jsx';

const NAV = [
  { to: '/', label: 'Queue', end: true },
  { to: '/mine', label: 'My cases' },
];

const ADMIN_ROLES = ['super_admin', 'project_admin', 'clinical_supervisor', 'ict_admin'];

export default function Sidebar() {
  const { staff, logout } = useAuth();
  const nav = ADMIN_ROLES.includes(staff?.role) ? [...NAV, { to: '/staff', label: 'Staff' }] : NAV;
  return (
    <aside className="w-60 shrink-0 bg-ink text-white flex flex-col h-screen sticky top-0">
      <div className="px-5 py-6">
        <div className="font-semibold text-lg tracking-tight">Sauti</div>
        <div className="text-xs text-white/50 mt-0.5">Caritas of Hope</div>
      </div>
      <nav className="flex-1 px-3 space-y-1">
        {nav.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `block rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive ? 'bg-white/10 text-white' : 'text-white/70 hover:bg-white/5 hover:text-white'
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="px-4 py-4 border-t border-white/10">
        <div className="text-sm font-medium truncate">{staff?.name}</div>
        <div className="text-xs text-white/50 capitalize">{staff?.role?.replace('_', ' ')}</div>
        <button
          onClick={logout}
          className="mt-3 text-xs text-white/60 hover:text-white underline underline-offset-2"
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
